import styled from 'styled-components';
import { BasketOptionalPartsStyled } from '../BasketOptionalPartsStyled';
import { rem } from 'polished';

export const BasketOptionalPartsDetailsOV = styled(BasketOptionalPartsStyled)`
    .parts {
        &__title {
            font-size: ${rem(20)};
        }
        
        &__description {
            margin-top: 0;
        }
        
        .part {
            border-color: ${({ theme }) => theme.colors.grey18};
            
            &:hover {
                border-color: ${({ theme }) => theme.colors.primaryHover};
                background: ${({ theme }) => theme.colors.pureWhite};
            }
            
            &.selected {
                background: ${({ theme }) => theme.colors.grey10};
                border-color: ${({ theme }) => theme.colors.primaryHover};
            }
            
            &__name {
                font-size: ${({ theme }) => theme.fontSizes.textMedium};  
            }
        }
    }
`;